// Dependencies
import React from 'react';
import { Route, Switch } from 'react-router-dom';


// Components
import App from './routes/App';
import AdminApp from './routes/AdminApp';
import Show from './components/Admin/Show';
import Create from './components/Admin/Create';
import Edit from './components/Admin/Edit';
import CategoriaCreate from './components/Admin/CategoriaCreate';
import CategoriaLista from './components/Admin/CategoriaLista';
import CategoriaShow from './components/Admin/CategoriaShow';
import CategoriaEdit from './components/Admin/CategoriaEdit';
import AdicionalCreate from './components/Admin/AdicionalCreate';
import AdicionalLista from './components/Admin/AdicionalLista';
import AdicionalShow from './components/Admin/AdicionalShow';
import AdicionalEdit from './components/Admin/AdicionalEdit';
import Pedidos from './components/Admin/Pedidos';
import Login from './components/Admin/Login';

const AppRoutes = () =>

    <Switch>
      <Route exact path="/admin" component={AdminApp} />
      <Route path='/admin/edit/:id' component={Edit} />
      <Route path='/admin/show/:id' component={Show} />
      <Route path='/admin/create' component={Create} />
      <Route path='/admin/categoria/create' component={CategoriaCreate} />
      <Route path='/admin/categoria/lista' component={CategoriaLista} />
      <Route path='/admin/categoria/show/:id' component={CategoriaShow} />
      <Route path='/admin/categoria/edit/:id' component={CategoriaEdit} />
      <Route path='/admin/adicional/create' component={AdicionalCreate} />
      <Route path='/admin/adicional/lista' component={AdicionalLista} />
      <Route path='/admin/adicional/show/:id' component={AdicionalShow} />
      <Route path='/admin/adicional/edit/:id' component={AdicionalEdit} />
      <Route path='/admin/pedidos' component={Pedidos} />
      <Route path='/admin/login' component={Login} />
      <Route exact path="/" component={App} />
    </Switch>


export default AppRoutes;
